import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUnlockComponent } from "./med-icon-unlock.component";

@NgModule({
  declarations: [
    MedIconUnlockComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUnlockComponent,
  ],
})
export class MedIconUnlockModule { }
